export default __webpack_public_path__ + "static/media/utility4.a5db5cca.svg";